import { type WorkspaceInvitationResource } from '@/features/opportunities/api/resources/workspace-posting-opportunity'
import { type WorkspaceInvitationProps } from './WorkspaceInvitation'
import { maybeParseDate } from '@/utils/date-util'

/**
 * Maps an invitation to apply to a workspace posting.
 */
export function mapWorkspaceInvitationResourceToProps(
  resource: WorkspaceInvitationResource,
): Partial<WorkspaceInvitationProps> {
  return {
    id: resource.id,
    workspaceId: resource.workspace_id,
    primarySoftware: resource.primary_software,
    supplementalSoftware: resource.supplemental_software,
    location: resource.location,
    description: resource.description,
    specialties: resource.specialties,
    dateCreated: maybeParseDate(resource.date_created),
    dateModified: maybeParseDate(resource.date_modified),
    dateInvited: maybeParseDate(resource.date_invited),
  }
}
